import React from "react";
import { Link } from "react-router-dom";

const FooterLinks = () => {
 return (
 <div
 style={{
 backgroundColor: "#f5f5f5",
 padding: "20px",
 marginTop: "40px",
 borderTop: "1px solid #ddd"
 }}
 >
 <div style={{ maxWidth: "900px", margin: "0 auto" }}>
 <h3 style={{ marginBottom: "10px" }}>Important Links</h3>

 <ul style={{ listStyle: "none", paddingLeft: 0, lineHeight: "1.8" }}>
 <li>
 <Link to="/privacy-policy">Privacy Policy</Link>
 </li>
 <li>
 <Link to="/terms-and-conditions">Terms & Conditions</Link>
 </li>
 <li>
 <Link to="/cancellation-refund">Cancellation & Refund Policy</Link>
 </li>
 <li>
 <Link to="/shipping-policy">Shipping & Delivery Policy</Link>
 </li>
 <li>
 <Link to="/contact">Contact Us</Link>
 </li>
 </ul>
 </div>
 </div>
 );
};

export default FooterLinks;
